import { useEffect, useState } from "react";
import { useAuth } from "@/lib/hooks/use-auth";
import { getUserProfile } from "@/lib/profile";

export function useAdmin() {
  const { user, loading: authLoading } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      if (authLoading) return;
      if (!user) {
        setIsAdmin(false);
        setLoading(false);
        return;
      }

      try {
        const profile = await getUserProfile(user.id, user.email || undefined);
        // Fallback: treat specific emails as admin even if profile is missing flag
        const adminEmails = new Set([
          "gany.wicaksono@gmail.com",
          "amirsafruddin99@gmail.com",
        ]);
        const isEmailAdmin = user.email ? adminEmails.has(user.email) : false;
        setIsAdmin(Boolean(profile?.is_admin) || isEmailAdmin);
      } catch (err) {
        console.error("Error checking admin status:", err);
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [user, authLoading]);

  return { isAdmin, loading };
}
